import { createGlobalStyle } from "styled-components";
import colors from "./colors.js";

const GlobalStyle = createGlobalStyle`


   
    /* cookieyes */
/* .cky-btn-revisit-wrapper {
  display: none !important;
} */
main{

}



    *{
        margin: 0;
        padding: 0;
        font-family: 'BastardoGrotesk-Semibold', sans-serif;
        font-display: swap;
        color: ${colors.white};
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        font-weight: lighter;

        border: none;

        @media (min-width: 1440px) {
            /* font-size: 0.0695vw; */

            }
    }

 
    div[data-placeholder-image]{
        background-color: transparent !important;
    }


    html {
    width: 100%; 
font-size: 62.5%;
    @media (min-width: 1730px) {
        font-size: 0.578vw;
        font-size: clamp(62.5%, .578vw, 75%);
    }}  

 body{

     width: 100vw;
     font-size:  1.4rem ; 
     background-color: ${colors.dark};

 }

h1, h2, h3, h4, h5, h6{
    text-transform: uppercase;

}
 
 strong {

    }

    button{
        border: none;
        margin: 0;
        padding: 0;
        width: auto;
        overflow: visible;
        background: transparent;
        color: inherit;
        font: inherit;
        line-height: normal;
        -webkit-font-smoothing: inherit;
        -moz-osx-font-smoothing: inherit;
        -webkit-appearance: none;

    
        
    }
  
    
    ::selection {
        background-color: ${colors.white} ;
        color: ${colors.dark};
    }
    
    ::-moz-selection {
        background-color: ${colors.white}95;
        color: black;
    }
`;

export default GlobalStyle;
